import { TitleText, Col, Button, UtilityText } from '@policygenius/mortar';
import React from 'react';

import NavigatorContent from 'components/NavigatorContent';

import styles from './onboarding.module.scss';

const STEPS = ['Tell us about yourself', 'Review your quotes', 'Apply for coverage'];

interface Props {
  onClick: VoidFunction;
}

const Onboarding: React.FC<Props> = ({ onClick }) => (
  <NavigatorContent>
    <Col span={{ medium: 6 }} push={{ medium: 3 }}>
      <div className={styles.headerWrapper}>
        <UtilityText color="secondary" weight="bold">
          Life insurance
        </UtilityText>
        <TitleText>How it works</TitleText>
      </div>

      <div>
        {STEPS.map((step, idx) => (
          <>
            <div className={styles.item} key={step}>
              <div className={styles.circle}>
                <UtilityText color="white" size="small">
                  {idx + 1}
                </UtilityText>
              </div>

              <UtilityText size="large" weight="bold">
                {step}
              </UtilityText>
            </div>
          </>
        ))}
      </div>

      <Button onClick={onClick} className={styles.button}>
        Let's start
      </Button>
    </Col>
  </NavigatorContent>
);

export default Onboarding;
